import axios, { type AxiosResponse } from '@fs/zion-axios'
import { ROOTSTECH_SERVICE as SERVICE } from '../../serviceNames'
import { sessionMetricsConfig } from '../../../config/sessionMetrics'
import { JSON_CONFIG } from '../../helpers/requestConfig'

// DOCS: https://icseng.atlassian.net/wiki/x/4Ir2Bw

type SessionRatingParams = { sessionId: string; cisId: string }
type SessionParams = { sessionId: string }
type TopWatchedParams = { lang: string; from?: string; until?: string; limit?: number }

const BASE = `${SERVICE}/session-metrics`

export const getUserSessionRating = async ({ sessionId, cisId }: SessionRatingParams): Promise<AxiosResponse> => {
  return axios.get(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, JSON_CONFIG)
}

export const deleteUserSessionRating = async ({ sessionId, cisId }: SessionRatingParams): Promise<AxiosResponse> => {
  return axios.delete(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, JSON_CONFIG)
}

export const getSessionMetrics = async ({ sessionId }: SessionParams): Promise<AxiosResponse> => {
  return axios.get(`${BASE}/sessions/${sessionId}`, JSON_CONFIG)
}
export const getSessionRatings = async ({ sessionId }: SessionParams): Promise<AxiosResponse> => {
  return axios.get(`${BASE}/sessions/${sessionId}/ratings`, JSON_CONFIG)
}

// valid values for userRating are 1 (likes) and -1 (dislikes)
export const getUserRatings = async ({ userRating = 1 }: { userRating?: number } = {}): Promise<AxiosResponse> => {
  return axios.get(`${BASE}/sessions?userRating=${userRating}`, JSON_CONFIG)
}

export const updateUserSessionRatings = async (
  { sessionId, cisId }: SessionRatingParams,
  body?: Record<string, unknown>
): Promise<AxiosResponse> => {
  return axios.put(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, body, JSON_CONFIG)
}

export const getTopRatedSessionsByLanguage = async ({ lang }: { lang: string }): Promise<AxiosResponse> => {
  return axios.get(`${BASE}/popular-sessions/${lang}`, JSON_CONFIG)
}

export const getTopWatchedSessionsByLanguage = async ({
  lang,
  from,
  until,
  limit,
}: TopWatchedParams): Promise<AxiosResponse> => {
  const langLimit =
    limit ?? sessionMetricsConfig.watchedLimitByLanguage[lang] ?? sessionMetricsConfig.defaultWatchedLimit
  const params = new URLSearchParams()
  if (from) params.append('from', from)
  if (until) params.append('until', until)
  params.append('limit', langLimit)
  return axios.get(`${BASE}/top-watched-sessions/${lang}?${params.toString()}`, JSON_CONFIG)
}
